__turbopack_context__.v({
  "banner": "NotificationBanner-module___53QrW__banner",
  "body": "NotificationBanner-module___53QrW__body",
  "hasBody": "NotificationBanner-module___53QrW__hasBody",
  "highlight": "NotificationBanner-module___53QrW__highlight",
  "icon": "NotificationBanner-module___53QrW__icon",
  "positive": "NotificationBanner-module___53QrW__positive",
  "text": "NotificationBanner-module___53QrW__text",
  "title": "NotificationBanner-module___53QrW__title",
  "warning": "NotificationBanner-module___53QrW__warning",
});
